export const CREATE_MCC_MUTATION = gql`
    mutation CreateMccMutation($input: CreateMccInput!) {
        createMcc(input: $input) {
            id
            name
            code
            risk
            formattedDescription {
                text
                type
            }
            documents
            formattedDocuments {
                text
                type
            }
        }
    }
`;

export const UPDATE_MCC_MUTATION = gql`
    mutation UpdateMccMutation($id: Int!, $input: UpdateMccInput!) {
        updateMcc(id: $id, input: $input) {
            id
            name
            code
            risk
            description
            formattedDescription {
                text
                type
            }
            documents
            formattedDocuments {
                text
                type
            }
        }
    }
`;

export const DELETE_MCC_MUTATION = gql`
    mutation deleteMcc($id: Int!) {
        deleteMcc(id: $id) {
            id
            code
        }
    }
`;
